module.exports = __webpack_public_path__ + "images/gavdos/bg2.jpg";